<template>
  <nav id="site-navigation" class="has-branding main-navigation nav-align-right sub-menu-right" aria-label="Primary"
    itemtype="https://schema.org/SiteNavigationElement" itemscope>
    <div class="inside-navigation">
      <div class="navigation-branding">
        <div class="site-logo">
          <a href="/" title="GBWhatsApp" rel="home">
            <img class="header-image is-logo-image" alt="GBWhatsApp" src="../assets/1.webp" title="GBWhatsApp">
          </a>
        </div>
        <div class="main-title" itemprop="headline">
          <a id="webName" href="/" rel="home">
            {{ $siteName }}
          </a>
        </div>
      </div>
      <!-- mobile的点击菜单 -->
      <ul id="menu-primary-menu" class="menu sf-menu mobile-menu-page" v-show="isMenuClicked">
        <li id="homeLink" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
          <a href="/">GB WhatsApp</a>
        </li>
        <li id="downloadLink" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
          <a href="/download/" class="download-btn">Download</a>
        </li>
        <li class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
          <a href="/gb-whatsapp-apk-for-pc-windows/">For PC</a>
        </li>
        <li class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
          <a href="/gb-whatsapp-for-ios/">For iOS</a>
        </li>
        <li class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
          <a href="/gb-whatsapp-old-versions/">Old Versions</a>
        </li>
        <li id="downloadLink" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
          <a href="/blog/">Blog</a>
        </li>

      </ul>

      <div id="primary-menu" class="main-nav">
        <!-- mobile -->
        <div class="mobile-menu" v-if="$global.isMobileDevice()">
          <div class="menu-toggle" @click="isMenuClicked = !isMenuClicked">
            <img src="@/assets/menu.svg" alt="menu button" v-if="!isMenuClicked">
            <img src="@/assets/xmark-black.svg" alt="close button" v-else>
          </div>
        </div>
        <!-- pc -->
        <div v-else id="menu-primary-menu" class="" style="display: flex; flex-wrap: wrap; gap: 16px; align-items: center;">
          <div id="homeLink" class="">
            <a href="/">GB WhatsApp</a>
          </div>
          <div id="downloadLink" class=" ">
            <a href="/download/" class="download-btn">Download</a>
          </div>
          <div class=" ">
            <a href="/gb-whatsapp-apk-for-pc-windows/">For PC</a>
          </div>
          <div class=" ">
            <a href="/gb-whatsapp-for-ios/">For iOS</a>
          </div>
          <div class=" ">
            <a href="/gb-whatsapp-old-versions/">Old Versions</a>
          </div>
          <div id="downloadLink" class=" ">
            <a href="/blog/">Blog</a>
          </div>

        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  props: {
    selectedLanguage: {
      type: String,
      required: true,
    },
    page: {
      type: String,
      required: true,
    },
    gotodownload: {
      type: Function,
    },
    apk: {
      type: [Object, String],
    },
  },

  data() {
    return {
      isHovered: false,
      isMenuClicked: false,
      isModClicked: false,
      isSearchClicked: false,
      lang: [{
        lang: 'en',
        val: '🇺🇸 English'
      },
      {
        lang: 'ar',
        val: '🇦🇪 اَلْعَرَبِيَّةُ'
      },
      {
        lang: 'id',
        val: '🇮🇩 Bahasa Indonesia'
      },
      {
        lang: 'pt',
        val: '🇵🇹 Português'
      },
      {
        lang: 'es',
        val: '🇪🇸 Español'
      },
      {
        lang: 'hi',
        val: '🇮🇳 हिंदी'
      },
      ],
      translation: {
        en: {
          home: 'Home',
          download: 'Download',
          blogs: 'Blogs',
          mod: 'WhatsApp Mods',
        },
        ar: {
          home: 'الصفحة الرئيسية',
          download: 'تحميل',
          blogs: 'المدونات',
          mod: 'مودات واتس اب',
        },
        id: {
          home: 'Beranda',
          download: 'Unduh',
          blogs: 'Blog',
          mod: 'Mod WhatsApp',
        },
        pt: {
          home: 'Casa',
          download: 'Baixar',
          blogs: 'Blogs',
          mod: 'Mods do WhatsApp',
        },
        es: {
          home: 'Casa',
          download: 'Descargar',
          blogs: 'Blogs',
          mod: 'Mods de WhatsApp',
        },
        hi: {
          home: 'घर',
          download: 'डाउनलोड',
          blogs: 'ब्लॉग',
          mod: 'व्हाट्सएप मोड्स',
        },
      },
    }
  },
  watch: {
    isSearchClicked(newVal) {
      if (!newVal) {
        this.$refs.searchComponent?.resetSearch();
      }
    }
  },
  methods: {
    changeLanguage(lang) {
      console.log("changelang: ", lang);
      console.log("page: ", this.page);
      this.$router.push({
        name: `${this.selectedLanguage}-${this.page}`
      });
    },
    download() {
      if (typeof this.gotodownload === "function") {
        this.gotodownload();
      } else {
        console.error("gotodownload is not a function");
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#site-navigation {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

  .inside-navigation {
    width: 80%;
    margin: 0 auto;
    z-index: 9999;
    position: relative;
  }
}

#backtop {
  width: 30px;
  height: 30px;
  position: fixed;
  right: 50px;
  bottom: 100px;
  background: #f0f0f0;
  padding: 10px;
  border-radius: 50%;
  box-sizing: content-box;

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.main-nav {
  .menu {
    list-style-type: none !important;
    margin: 0 !important;

    li {
      a {
        font-weight: 500 !important;
      }
    }
  }
}

@media screen and (max-width: 768px) {

  .inside-navigation {

    .mobile-menu-page {
      position: absolute;
      top: 100%;
      width: 100%;
      z-index: 1001;
      margin: 0 !important;

      .menu-item {
        padding: 14px 0;
        margin-bottom: 0 !important;
        background: #fff;

        a,
        div {
          font-size: 15px;
          text-align: center;
          color: #121212;
          display: block;
        }
      }
    }
  }

  .main-nav {
    flex: 1;
    margin-right: 10px;

    .mobile-menu {
      display: flex;
      justify-content: flex-end;
      position: relative;

      .language-selector {
        width: 60%;

        #language-select {
          width: 100%;
        }
      }

      .menu-toggle {
        display: block;
        display: flex;
        justify-content: center;
        padding: 12px 12px;
        margin-bottom: 0;

        img {
          filter: invert(1);
          width: 23px;
          height: 23px;
        }
      }

      .search-toggle {
        display: block;
        padding: 12px 12px;
        display: flex;
        justify-content: center;
        margin-bottom: 0;

        img {
          width: 23px;
          height: 23px;
        }
      }
    }
  }
}
</style>
